/**
 * Options for the "How did you find this apartment?" tenancy field.
 * Shared between web and mobile review flows so the values stay in sync.
 * `value` is the wire value (snake_cased on submit); `label` is the display text.
 */
export const REVIEW_LISTING_SOURCE_OPTIONS = [
    { value: 'streeteasy', label: 'StreetEasy' },
    { value: 'zillow', label: 'Zillow' },
    { value: 'openigloo', label: 'Openigloo' },
    { value: 'apartments_com', label: 'Apartments.com' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'craigslist', label: 'Craigslist' },
    { value: 'other', label: 'Other' },
];
/**
 * Options for the "How long was the sublet?" tenancy field.
 * Shared between web and mobile review flows so the values stay in sync.
 * `value` is the wire value (snake_cased on submit); `label` is the display text.
 */
export const REVIEW_SUBLET_DURATION_OPTIONS = [
    { value: 'less_than_1_month', label: 'Less than 1 month' },
    { value: '1_2_months', label: '1–2 months' },
    { value: '3_5_months', label: '3–5 months' },
    { value: '6_11_months', label: '6–11 months' },
    { value: '12_months_or_more', label: '12 months or more' },
];
/**
 * Options for the "How did you find your subtenant?" tenancy field.
 * Shared between web and mobile review flows so the values stay in sync.
 * `value` is the wire value (snake_cased on submit); `label` is the display text.
 */
export const REVIEW_SUBTENANT_SOURCE_OPTIONS = [
    { value: 'facebook', label: 'Facebook' },
    { value: 'craigslist', label: 'Craigslist' },
    { value: 'friends_or_family', label: 'Friends or family' },
    { value: 'other', label: 'Other' },
];
export const reviewInfo = [
    {
        title: 'Cleanliness',
        key: 'cleanliness',
        apiKey: 'ratingCleanliness',
        description: '1 (unmanaged) to 5 (well managed)',
        aggKey: 'avgCleanliness',
        iconName: 'IconBroom',
    },
    {
        title: 'Trash management',
        key: 'garbageManagement',
        apiKey: 'ratingGarbageManagement',
        description: '1 (poorly managed) to 5 (well organized)',
        aggKey: 'avgGarbageManagement',
        iconName: 'IconTrash',
    },
    {
        title: 'Pest control',
        key: 'pestControl',
        apiKey: 'ratingPestControl',
        description: '1 (lots of pests) to 5 (no pests)',
        aggKey: 'avgPestControl',
        iconName: 'IconBug',
    },
    {
        title: 'Water pressure',
        key: 'waterPressure',
        apiKey: 'ratingWaterPressure',
        description: '1 (weak) to 5 (strong)',
        aggKey: 'avgWaterPressure',
        iconName: 'IconWaterTap',
    },
    {
        title: 'Heat',
        key: 'heat',
        apiKey: 'ratingHeat',
        description: '1 (faulty) to 5 (working)',
        aggKey: 'avgHeat',
        iconName: 'IconTemperature',
    },
    {
        title: 'Neighbors',
        key: 'neighbors',
        apiKey: 'ratingNeighbors',
        description: '1 (loud / disrespectful) to 5 (friendly and considerate)',
        aggKey: 'avgNeighbors',
        iconName: 'IconGroup',
    },
    {
        title: 'Noise levels',
        key: 'noiseLevels',
        apiKey: 'ratingNoiseLevels',
        description: '1 (loud) to 5 (quiet)',
        aggKey: 'avgNoiseLevels',
        iconName: 'IconVolumeUp',
    },
    {
        title: 'Owner responsiveness',
        key: 'ownerResponsiveness',
        apiKey: 'ratingOwnerResponsiveness',
        description: '1 (slow) to 5 (timely)',
        aggKey: 'avgOwnerResponsiveness',
        iconName: 'IconConversation',
    },
];
